import { ng } from '@uirouter/angularjs/lib/angular';
import angular = require('angular');
import { ngStorage } from 'ngstorage';
import _ = require('underscore');
import { NotificationService } from '../../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../../app.common/modules/common/services/popup.service';
import { ExtraItemModel, ProductExtraItemModel } from '../../../../core';
import { ExtrasService } from '../../../../extras/extras.service';
import { IProductExtraItemModel } from '../../../models';

class ProductExtrasList implements ng.IController {
    public static $inject = ['$translate', 'popupService', '$uibModal', 'notificationService', 'extrasService', '$localStorage'];
    public items: IProductExtraItemModel[];
    public countryID: number;

    public treeOptions = {
        accept(sourceNodeScope: any, destNodesScope: any) {
            return sourceNodeScope.$modelValue.ItemTypeID === destNodesScope.$modelValue[0].ItemTypeID ? true : false;
        },
        dragStart(event: any) {
            event.elements.dragging[0].classList.add('drag-item');
        },
        dropped(event: any) {
            event.elements.dragging[0].classList.remove('drag-item');
        }
    };

    constructor(
        protected $translate: angular.translate.ITranslateService,
        private popupService: PopupService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        public notificationService: NotificationService,
        private extrasService: ExtrasService,
        private $localStorage: ngStorage.StorageService
    ) {
    }

    $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
    }

    public getImage(imageID: string) {
        return this.extrasService.getExtraImageUrl(imageID);
    }

    public deleteExtra = async (deleteItem: ProductExtraItemModel) => {
        const extraToDeleteIndex = this.items.findIndex((item) => item.ID === deleteItem.ID);
        if (extraToDeleteIndex > -1) {
            this.items.splice(extraToDeleteIndex, 1);
        }
    }

    public addExtra = async () => {

        let operationResult: any;
        try {
            operationResult = await this.$uibModal.open({
                component: 'selectExtras',
                size: 'md',
                resolve: {
                    options: () => {
                        return {
                            selectedExtras: this.items,
                        };
                    }
                },
                backdrop: 'static',
            }).result;
        } catch (error) {
            return;
        }

        if (operationResult && operationResult.status === 'ok') {
            const selectedExtras = operationResult.selectedExtras as ExtraItemModel[];
            const newSelectedExtras: IProductExtraItemModel[] = [];

            selectedExtras.forEach((extra) => {
                const foundExtra = _.find(this.items, (item) => {
                    return item.ID === extra.ID;
                });
                if (foundExtra) {
                    newSelectedExtras.push(foundExtra);
                } else {
                    const productExtra = {
                        ID: extra.ID,
                        ImageID: extra.ImageID,
                        Title: extra.Title,
                        Price: extra.Price,
                        MaxAmount: 1,
                        CurrencySign: extra.CurrencySign
                    } as IProductExtraItemModel;
                    newSelectedExtras.push(productExtra);
                }
            });
            this.items = newSelectedExtras;
        }
    }

}

angular.module('naut').component('productExtrasList', {
    template: require('./product-extras-list.component.html'),
    controller: ProductExtrasList,
    controllerAs: 'ctrl',
    bindings: {
        items: '='
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-extras-list/product-extras-list.component.ts